import { DestroyRef, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BeforeUnloadService {
  /**
   * Registers a browser-level beforeunload warning that fires when the page is
   * closed or refreshed while `hasUnsavedChanges()` returns true. The listener
   * is automatically removed when the component is destroyed via DestroyRef.
   *
   * In-app navigation is handled separately by the route guard.
   */
  public register(hasUnsavedChanges: () => boolean, destroyRef: DestroyRef): void {
    const handler = (event: BeforeUnloadEvent): void => {
      if (hasUnsavedChanges()) {
        event.preventDefault();
      }
    };
    window.addEventListener('beforeunload', handler);
    destroyRef.onDestroy(() => window.removeEventListener('beforeunload', handler));
  }
}
